<template>

  <div class="modal" :id="mid">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Редакция на файл</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if='file' class='row'>
                        <div class="col-12 mb-3">
                            {{ file.name }}
                        </div>
                        <div class="col-12 mb-3">
                            <label for='ed-title'>
                                Име на файла
                            </label>
                            <input id='ed-title' v-model.trim='file.title' 
                                        class='form-control'>
                        </div>
                        <div class="col-12 mb-3">
                            <label for='ed-desc'>
                                Описание на файла
                            </label>
                            <textarea id='ed-desc' v-model.trim='file.desc' 
                                      class='form-control'></textarea>
                        </div>

                        <div class="col-12 text-center">
                            <button @click='saveEdit' class='btn btn-success'>
                                Запази
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        props : ['file','mid'],

        data() {
            return {
                isReady : false,
                forEdit : false
            }
        },

        methods : {

            saveEdit( f ) {

                this.ajax.call('prj:edf', this.file , (r) => {
                    
                    if( r.status == 'success' ) {

                        $("#" + this.mid).modal('hide');
                        $.notify("Редакцията беше успешна","success");
                    
                    }

                })

            },
        }

    }
</script>
